<template>
  <div class="default-layout">
    <div
      id="viewport"
      class="w-100 relative"
    >
      <customer-list />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import CustomerList from '../components/CustomerList.vue';

export default {
    components: {
        CustomerList
    },
    methods: {
        ...mapActions('customers',
                ['getCustomers'])
    },
}
</script>
